module.exports = __webpack_public_path__ + "static/media/pic_banner_partneredBusiness.d4d7dcc8.jpg";